// TermsAndConditionsPage.jsx
import React from 'react';
import './LeaderBoard.css'; // CSS for styling this page

const PrivacyPolicy = () => {
  return (
    <div className="terms-conditions-container">
      <div className="terms-conditions-content">
        <h1>Privacy Policy</h1>

        <h2>WannaPractice Privacy Statement</h2>
        <p>Effective Date: January 12th, 2023</p>
        <p>
          WannaPractice is a product of iVox Learning LLC. We at iVox.ai (iVox Learning
          LLC and our affiliates) are committed to protecting your privacy. This Privacy
          Policy applies to all of our websites (Websites), including
          www.wannapractice.com, app.wannapractice.com,
          www.iVox.ai, and any other website owned and controlled
          by iVox.ai. This Privacy Policy governs our data collection, processing and
          usage practices. It also describes your choices regarding use, access and
          correction of your personal information. By using the Websites you consent to
          the data practices described in this Privacy Policy. If you do not agree with
          the data practices described in this Privacy Policy, you should not use the
          Websites.
        </p>
        <p>
          We periodically update this Privacy Policy. We encourage you to
          review this Privacy Policy periodically.
        </p>
        <p>
          If you have any questions about our treatment of the information you
          provide us or this Privacy Policy, please write to us by email at{' '}
          <a href="mailto:privacy@wannapractice.com">privacy@wannapractice.com</a> or by mail to iVox.ai 5201 Great America Pkwy, Suite
          320, Santa Clara, CA 95054, Attn: Privacy Policy.
        </p>

        <h2>Disclosures Specific to iVox.ai Services</h2>
        <p>
          iVox.ai may collect some personal information under the
          direction of its Clients and has no direct relationship with the individuals
          whose personal data it processes. If you are an employee, contractor, user,
          and/or customer of one of our Clients that use our service, please contact the
          Client that you interact with directly. Personal information collected through
          our application can include, but is not limited to User IDs (which can include
          email addresses), IP addresses, operating system, access methods, applications
          and cloud services accessed, File Object (like file name or email subject),
          length of connection, etc. We process the information included in file/Social
          media contents to scan for threats and for the purposes of data loss prevention.
          We store the metadata about the results of this processing which does not
          include any of the contents other than the file name. We do not share or
          transfer information collected through our application with third parties for
          advertising/marketing purposes or otherwise unless aggregated and non-directly
          identifying, to help iVox.ai perform industry benchmarking of service usage,
          product usage trending, and for projecting business and operational scaling. We
          may transfer personal information to companies that help us provide our
          services. Transfers to subsequent third parties are covered by the service
          agreements with our Clients.
        </p>
        <p>
          An individual who seeks access, or who seeks to correct, amend, or
          delete inaccurate data should direct his query to the iVox.ai’s Client (the
          data controller). Upon receiving a request to remove data from a Client,
          iVox.ai will respond within a reasonable timeframe. iVox.ai will retain
          personal data we process on behalf of our Clients for as long as needed to
          provide services to our Client. iVox.ai will retain this personal information
          as necessary to comply with our legal obligations, resolve disputes, and enforce
          our agreements.
        </p>

        <h2>Information from visitors who request information</h2>
        <p>
          If you request information or services, we may require
          the submission of information at the time of request. We may require you to
          provide first and last name, corporate title, company name, a valid email
          address, phone number, or other information. You may also have the option to
          give us more information if you want to. The information we require or request
          may include “Visitor Personal Information.”
        </p>
        <p>
          “Visitor Personal Information” is any information about one of our
          visitors which could, alone or together with other information, personally
          identify him or her. Information such as a real name, an email address, and a
          phone number are examples of “Visitor Personal Information.”
        </p>
        <p>
          Visitor Personal Information does not include aggregated,
          non-personally identifying information. We may use aggregated, non-personally
          identifying information to operate, improve, and optimize our website and
          service.
        </p>

        <h2>What information iVox.ai does not collect</h2>
        <p>
          We do not intentionally collect sensitive personal
          information, such as social security numbers, credit card or other financial
          information, health information, or religious information. Although iVox.ai
          does not request or intentionally collect any sensitive personal information, we
          realize that you might submit this kind of information to us through free form
          text fields. If you submit this type of information to our website, you are
          consenting to our storage of that information on our servers and in the servers
          of our marketing and email vendors, which are in the United States. If you
          believe that you have inadvertently submitted sensitive personal information
          about you to us, please contact us at{' '}
          <a href="mailto:privacy@wannapractice.com">privacy@wannapractice.com</a>, so that we may
          delete the information.
        </p>
        <p>
          The Websites are not intended for or targeted at children under 13,
          and we do not knowingly or intentionally collect information about children
          under 13. If you believe that we have collected information about a child under
          13, please contact us at{' '}
          <a href="mailto:privacy@wannapractice.com">privacy@wannapractice.com</a>, so that we may delete the
          information.
        </p>

        <h2>How we use and share the information we collect</h2>
        <p>
          In addition to the uses identified elsewhere in this
          Privacy Policy, we may use your Visitor Personal Information to:
        </p>
        <ul>
          <li>improve your browsing experience by personalizing the Websites;</li>
          <li>perform user identification;</li>
          <li>enable sales, marketing, and business transactions;</li>
          <li>
            send information to you which we think may be of interest to you by post,
            email, or other means;
          </li>
          <li>
            send you marketing communications relating to our business or the businesses
            of carefully-selected third parties which we think may be of interest to
            you; and
          </li>
          <li>
            provide other companies with statistical information about our users — but
            this information will not be used to identify any individual user.
          </li>
        </ul>
        <p>
          We may share Visitor Personal Information with trusted partners to contact you
          based on your request to receive such communications, so we can perform services you
          have requested, to help us perform statistical analysis, or to provide customer
          support.
        </p>
        <p>
          We may share Visitor Personal Information with a limited number of
          third-party vendors who process it on our behalf to provide or improve our service.
          Our vendors perform services such as marketing, advertising, payment processing,
          customer support ticketing, network data transmission, and other similar services.
        </p>
        <p>
          We may share Visitor Personal Information if we are involved in a
          merger, sale, or acquisition.
        </p>
        <p>
          We may occasionally embed content from third party sites, such as
          YouTube, and that content may include ads. While we try to minimize the amount of
          ads our embedded content contains, we can’t always control what third parties show.
        </p>
        <p>
          We do not sell, rent, or trade Visitor Personal Information with third
          parties for their commercial purposes.
        </p>
        <p>
          We do share certain aggregated, non-personally identifying information
          with others about how our users, collectively, use iVox.ai, or how our users
          respond to our other offerings, such as our conferences or events. However, we do
          not sell this information to advertisers or marketers.
        </p>

        <h2>Our use of cookies, tracking, beacons and analytics</h2>
        <p>
          <a href="/cookie-policy/">Cookie Policy</a>
        </p>

        <h2>Retention of Visitor Personal Information</h2>
        <p>
          We retain Visitor Personal Information that you provide
          us as long as we consider it potentially useful in contacting you about our
          services.
        </p>

        <h2>International Transfer of Information</h2>
        <p>
          Information that we collect will be stored and processed
          in the United States in accordance with this Privacy Statement. To facilitate
          our global operations, we may transfer and access Visitor Personal Information
          from around the world, including the United States. This Privacy Policy shall
          apply even if we transfer Visitor Personal Information to other countries.
        </p>

        <h2>Compelled Disclosure</h2>
        <p>
          We reserve the right to use or disclose your Visitor
          Personal Information if required by law or if we reasonably believe that use or
          disclosure is necessary to protect our rights, protect your safety or the safety
          of others, investigate fraud, or comply with a law, court order, or legal
          process.
        </p>

        <h2>Opting Out and Unsubscribing</h2>
        <p>
          Upon request iVox.ai will provide you with information
          about whether we hold any of your Visitor Personal Information. If you provide
          us with your Visitor Personal Information, you have the following rights with
          respect to that information:
        </p>
        <ul>
          <li>To review the user information that you have supplied to us</li>
          <li>
            To request that we correct any errors, outdated information, or omissions in
            user information that you have supplied to us
          </li>
          <li>To request that your user information not be used to contact you</li>
          <li>
            To request that your user information be removed from any solicitation list
            that we use
          </li>
          <li>To request that your user information be deleted from our records</li>
          <li>To opt out of being solicited by iVox.ai or third parties</li>
        </ul>
        <p>
          To exercise any of these rights, please contact us at{' '}
          <a href="mailto:privacy@wannapractice.com">privacy@wannapractice.com</a> or by mail to 5201 Great America Pkwy, Suite 320, Santa
          Clara, CA 95054, Attn: Privacy Policy. We will respond to your request to change,
          correct, or delete your information within a reasonable timeframe and notify you of
          the action we have taken.
        </p>
        <p>
          You may unsubscribe from our marketing communications by clicking on the
          “unsubscribe” link located on the bottom of our e-mails, or by sending us email us
          at <a href="mailto:privacy@wannapractice.com">privacy@wannapractice.com</a>, or by sending us postal or snail mail to 5201 Great
          America Pkwy, Suite 320, Santa Clara, CA 95054, Attn: Privacy Policy.
        </p>

        <h2>Updates to this iVox.ai Privacy Statement</h2>
        <p>
          We may update this Privacy Statement from time to time.
          If we modify our Privacy Statement, we will post the revised version here, with
          an updated revision date. You agree to visit these pages periodically to be
          aware of and review any such revisions. If we make material changes to our
          Privacy Statement, we may also notify you by other means prior to the changes
          taking effect, such as by posting a notice on our websites or sending you a
          notification. By continuing to use our website after such revisions are in
          effect, you accept and agree to the revisions and to abide by them.
        </p>
        <p>
          The iVox.ai Privacy Statement was revised and posted as of January
          12th, 2023.
        </p>
        <p>
          For terms of use please <a href="./terms-and-conditions">Click Here</a>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;